import { Navigate } from 'react-router-dom';
const HomepageGuard = ({ isLoggedIn, children }: { isLoggedIn: boolean; children: any }) => {
    if (!isLoggedIn) {
        // make not logged in page
        return <Navigate to="/" replace />;
    }
    return children;
};
export default HomepageGuard;
